import * as Types from "../../../../../__generated__/types";
import {
    GetUploadDocumentsForBorderoQuery,
    ListBorderosForCarrierQuery,
} from "../queries.generated";
import { BeleganforderungRow } from "../beleganforderung/beleganforderungHelpers";

export interface BorderoStatusRow {
    borderoNumber: string;
    borderoPosition: string;
    positionCount: number;
    carrierNumber: string;
    borderoDate: string;
    orderArea: string;
    relation: string;
    goodsCategory: string;
    status: Types.BorderoEdpStatus;
    loadNumber: string;
    consignee: string;
    consignor: string;
    fsdNumber: string;
    volume?: number;
    weight?: number;
}

export function mapListBorderosForCarrierRows(
    entityRows: ListBorderosForCarrierQuery["listBorderosForCarrier"] extends { entity?: infer T } ? T : undefined,
): BorderoStatusRow[] {
    const rows = entityRows ?? [];
    const borderoPositionCounts = rows
        .filter((row): row is NonNullable<typeof row> => Boolean(row))
        .reduce<Record<string, number>>((acc, row) => {
            const borderoNumber = row.borderoNumber || "";
            if (!borderoNumber) {
                return acc;
            }
            acc[borderoNumber] = (acc[borderoNumber] || 0) + 1;
            return acc;
        }, {});

    return rows
        .filter((row): row is NonNullable<typeof row> => Boolean(row))
        .map((row) => {
            const borderoKey = row.borderoNumber ?? "";
            const fallbackPositionCount = borderoPositionCounts[borderoKey] ?? 0;

            return {
                borderoNumber: borderoKey,
                borderoPosition: row.borderoPosition || "",
                positionCount: row.countPosition ?? fallbackPositionCount,
                carrierNumber: row.carrierNumber || "",
                borderoDate: row.borderoDate || "",
                orderArea: row.orderArea || "",
                relation: row.relation || "",
                goodsCategory: row.goodsCategory || "",
                status: (row.status as Types.BorderoEdpStatus) || Types.BorderoEdpStatus.DocumentRequested,
                loadNumber: row.loadNumber || "",
                consignee: row.consignee || "",
                consignor: row.consignor || "",
                fsdNumber: row.fsdNumber || "",
                volume: row.volume ?? undefined,
                weight: row.weight ?? undefined,
            };
        });
}

export function mapGetUploadDocumentsForBorderoRows(
    rows: GetUploadDocumentsForBorderoQuery["getUploadDocumentsForBordero"],
): BeleganforderungRow[] {
    return (rows || [])
        .filter((item): item is NonNullable<typeof item> => Boolean(item))
        .map((item) => ({
            carrierNumber: item.carrierNumber || "",
            borderoNumber: item.borderoNumber || "",
            borderoDate: item.borderoDate || "",
            borderoPosition: item.borderoPosition || "",
            orderArea: item.orderArea || "",
            relation: item.relation || "",
            goodsCategory: item.goodsCategory || "",
            loadNumber: item.loadNumber || "",
            consignee: item.consignee || "",
            consignor: item.consignor || "",
            volume: item.volume ?? undefined,
            weight: item.weight ?? undefined,
            status: item.status || "",
        }));
}
